<!-- 企业社会责任 -->
<template>
    <div class="responsibility_c">
      <!-- <sub-banner id="id_about">
        <img src="../../assets/images/responsibility/responsibility_banner.jpg"/>
      </sub-banner> -->
      <div class="responsibility_content" v-if="active_menus=='company_responsition'">
          <div class="responsibility_info">
              <div class="info_title">{{$t('NavabarText.navbar_item')}}</div>
              <div class="info_desc">
                {{$t('NavabarText.navbr_item_desc')}}
              </div>
              <div class="info_img_content">
                  <div class="img_item">
                      <img src="../../assets/images/responsibility/responsibility_manager.jpg" />
                  </div>
              </div> 
          </div>
      </div>

      
      <div class="responsibility_info_story" v-if="active_menus=='company_story'&& responsibilityList.length>0">
          <div class="responsibility_contents">
             <div class="responsibility_infos">
              <div class="info_title">{{$t('NavabarText.navbar_item_story')}}</div>
             </div>
              <div class="responsibility_content_item" v-for="item in responsibilityList" :key="item.id" @click="watchresponsibility(item)">
                  <div class="responsibility_img">
                      <!-- <img src="../../assets/images/responsibility/responsibility_one.png" /> -->
                      <img :src="item.showImgUrl" />

                  </div>
                  <div class="responsibility_desc">
                      <div class="desc_titles">{{item.title}}</div>
                      <div class="desc_dates">
                       <div class="operator">发布时间： {{item.effectiveTime}}</div> 
                       <!-- <div class="hostipal">医院： {{item.hospitalName}}</div>  -->
                       <!-- <div class="dates">{{item.publishDate}}</div>  -->
                      </div>
                      <div class="desc_content">
                          {{item.articleAbstract}}
                      </div>
                  </div>
              </div>
              <div class="more_s" v-if="!isHiddedMore">
                <div class="more_c">
                   <div class="more_btn" @click="moreClick()">{{$t('indexText.more')}}</div>
                </div>
              </div>
          </div>
          
      
      </div>
      
      <div class="responsibility_info_story" v-if="active_menus=='support_part'&& supportPartList.length>0">
        <div class="responsibility_contents">
           <div class="responsibility_infos">
            <div class="info_title">{{$t('NavabarText.navbar_item_story')}}</div>
           </div>
            <div class="responsibility_content_item" v-for="item in supportPartList" :key="item.id" @click="watchresupportPart(item)">
                <div class="responsibility_img">
                    <!-- <img src="../../assets/images/responsibility/responsibility_one.png" /> -->
                    <img :src="item.showImgUrl" />

                </div>
                <div class="responsibility_desc">
                    <div class="desc_titles">{{item.title}}</div>
                    <div class="desc_dates">
                     <div class="operator">发布时间： {{item.effectiveTime}}</div> 
                     <!-- <div class="hostipal">医院： {{item.hospitalName}}</div>  -->
                     <!-- <div class="dates">{{item.publishDate}}</div>  -->
                    </div>
                    <div class="desc_content">
                        {{item.articleAbstract}}
                    </div>
                </div>
            </div>
            <div class="more_s" v-if="!isHiddedMore">
              <div class="more_c">
                 <div class="more_btn" @click="moreClick()">{{$t('indexText.more')}}</div>
              </div>
            </div>
        </div>
        
    
    </div>


      <div class="left_menus_r left_menus_position_r">
        <div class="menus_contents">
          <div class="memus_item" :class="active_menus=='company_responsition'?'menus_active':''" @click="active_menus='company_responsition'">{{$t('NavabarText.navbar_item')}}</div>
          <div class="memus_item" v-if="responsibilityList.length>0" :class="active_menus=='company_story'?'menus_active':''" @click="active_menus='company_story'">{{$t('NavabarText.navbar_item_story')}}</div>
          <div class="memus_item" v-if="supportPartList.length>0" :class="active_menus=='support_part'?'menus_active':''" @click="active_menus='support_part'">{{$t('NavabarText.support_part')}}</div>
        </div>
      </div>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'

import {getArticleByTypeList} from '../../service/service'
import SubBanner from "@/components/sub-banner";
export default {
  name: 'responsibility',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-企业社会责任',
      metaName:'广州市熵达贸易有限公司-企业社会责任',
      metaContent:'广州市熵达贸易有限公司-企业社会责任',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' ,  
      responsibilityList:[], 
      supportPartList:[],
      responsibilityStory:'responsibility_story',
      responsibilityStoryId:6,
      supportPartListId:8,
      isHiddedMore:false,
      active_menus:'company_responsition',
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
     async getArticleByCompanyeList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.responsibilityStoryId,pageNum,pageSize);
       if(resp&&resp.data){
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1;
           v.date=dateN.getDate();
           v.showImgUrl=process.env.BASE_IMG_URL+v.synopsisImg
          
         })
         this.responsibilityList=resp.data;
         
         if(this.responsibilityList.length==resp.total){
           this.isHiddedMore=true;
         }else{
           this.isHiddedMore=false;
         }
       }
    },

    
    async getArticleBySupportPartCompanyeList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.supportPartListId,pageNum,pageSize);
       if(resp&&resp.data){
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1;
           v.date=dateN.getDate();
           v.showImgUrl=process.env.BASE_IMG_URL+v.synopsisImg
          
         })
         this.supportPartList=resp.data;
         
         if(this.supportPartList.length==resp.total){
           this.isHiddedMore=true;
         }else{
           this.isHiddedMore=false;
         }
       }
    },
    watchresponsibility(item){
       this.$router.push({
            path: '/article?id='+item.id
        });
    },
    watchresupportPart(item){
       this.$router.push({
            path: '/article?id='+item.id
        });
    }
  },
  created () {

  },
  mounted () {
    this.getArticleByCompanyeList(1,3);
    this.getArticleBySupportPartCompanyeList(1,3)
    // $(window).scroll(function () {
    // console.log("$(window).scrollTop()",$(window).scrollTop())
    //   if ($(window).scrollTop() >= 400) {
    //       $('.left_menus').addClass('left_menus_position');
    //   }else{
    //     $('.left_menus').removeClass('left_menus_position');
    //   }
    // })
  },
}
</script>
<style lang='scss' scoped>

.responsibility_c{
    .responsibility_content{
        width:100%;
        background:#ffffff;
        .responsibility_info{
            width:70%;
            margin: auto;
            .info_title{
                margin-top:117px;
                font-size:40px;
                font-weight: bold;
                color:#4f7cbd;
            }
            .info_desc{
                margin-top:37px;
                font-size:18px;
                color:#333333;
                text-align: left;
                text-indent: 24px;
                line-height: 28px;

            }
            .info_img_content{
                margin-top:50px;
                // display: flex;
                // justify-content: space-between;
                // align-items: center;
                width:100%;
              .img_item{
                  margin-right:18px;
                  margin-bottom:20px;
                  &:last-child{
                      margin-right: 0px !important;
                  }
                  img{
                      width:100%;
                      height:100%;
                  }
              }   
            }

            .info_img_content_in{
                
                margin-top:130px;
                margin-bottom:120px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .img_item{

                    margin-right:18px;
                    margin-bottom:20px;

                    &:last-child{
                        margin-right: 0px !important;
                    }
                    img{
                        width:100%;
                        height:100%;
                    }
                    .img_item_title{
                        text-align: left;
                        margin-top:32px;
                        font-size:22px;
                        font-weight: bold;
                    }
                    .img_item_desc{
                        position: relative;
                        text-align: left;
                        margin-top:30px;
                        font-size:14px;
                        max-width:480px;
                        color: #999;
                    }
                    .img_item_desc::before{
                         content:" ";
                        position:absolute;
                        left:0;
                        top:-20px;
                        width:100%;
                        height:1px;
                        transform:scaleY(.8);
                        background-color:#eeeeee;
                    }
                }
            }
                  
        }
    }
}


.responsibility_info_story{
    width:100%;
    background:#fff;
    .responsibility_infos{
            width:70%;
            margin: auto;
            .info_title{
                margin-top:27px;
                font-size:40px;
                font-weight: bold;
                color:#4f7cbd;
                margin-bottom:47px;
            }
    }
    .responsibility_contents{
        width:70%;
        margin:auto;
        padding:120px 0px; 
        .responsibility_content_item{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom:80px;
            .responsibility_img{
                // width:268px;
                // height: 165px;
                img{
                    width:100%;
                    height: 100%;
                }
            }
            .responsibility_desc{
                width: 875px;
                margin-left:43px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                cursor: pointer;
                .desc_titles{
                    color:#333333;
                    font-size: 18px;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                .desc_dates{
                    color:#333333;
                    font-size: 15px;
                    margin-bottom: 15px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex-wrap: wrap;
                    .operator{
                      
                    } 
                    .hostipal{
                      margin-left:25px;
                    }
                    .dates{

                      margin-left:25px;
                    }
                }
                .desc_content{
                    text-align: left;
                    font-size: 16px;
                    color:#999999;
                    line-height: 31px;
                }
            }
            &:last-child{
                margin-bottom: 0px !important;
            }
        }
    }
}

    .more_s{
          width: 100%;
          text-align: center;
          .more_c{
            display: flex;
            justify-content: center;
            cursor: pointer;
            .more_btn{
              width: 147px;
              height: 49px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 25px;
              border: solid 2px #4f7cbd;
              color:#2750a2;
              font-size:20px;
              letter-spacing: 2px;
            }
            .more_btn:hover{
              background-color: #4f7cbd !important;
              color:#ffffff !important;
            }
          }
    }



.left_menus_position_r{
}
.left_menus_r{
  position: fixed;
  left:3%;
  top:25%;
  border-radius: 5px;
  color:#333333;
  .menus_contents{
  width:192px;
   .memus_item{
     padding-top:7px;
     padding-bottom: 10px;
     width: 100%;
    font-size:20px;
     cursor:pointer;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
     cursor:pointer;
    
   }
   .memus_item:hover{
     background:linear-gradient(left,#4f7cbd,#f3f4f7) !important;
     color:#ffffff !important;
     font-weight: bold !important;
   }
   .menus_active{
     background:linear-gradient(left,#4f7cbd,#f3f4f7) !important;
     color:#ffffff !important;
     font-weight: bold !important;
   }
   
  }
}
</style>




// WEBPACK FOOTER //
// src/view/responsibility/index.vue